import React, { useState, useEffect } from "react";
import axios from "axios";
import Highlighter from "react-highlight-words";
import { Link, useHistory } from "react-router-dom";
import Nav from "../searchtopics/Nav";
import "../../styles/searchresult.css";
import Cookies from "js-cookie";
import config from "../../config/config";
import { autoSuggestQuery } from "../../openSearchQueries";
import { getSpecialtyInAutoSuggest } from "../../helper/AutoSuggestHelper";

const TopicNav = () => {
  let history = useHistory();
  const [getApi, setFlag] = useState(false);
  const [url, setUrl] = useState("");
  const [searchkey, setSearchkey] = useState("");
  const [genus, setGenus] = useState(localStorage.getItem("genus"));
  const [optionList, setOptionList] = useState([]);

  useEffect(() => {
    let recentSearches =
      Cookies.get("searches") !== undefined
        ? Cookies.get("searches").split(",")
        : [];
    if (getApi) {
      axios
        .post(url, autoSuggestQuery(searchkey), {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            const setSuggestionList = async (suggestions) => {
              let optionsList = [];
              if (suggestions.length) {
                let suggestionWithSpecialty = await getSpecialtyInAutoSuggest(
                  suggestions
                );
                optionsList = (
                  <div className="autosuggest-container">
                    <ul className="options">
                      {recentSearches.length ? <p>Recent Searches</p> : ""}
                      {recentSearches.map((rs, index) => {
                        return (
                          <li key={rs} id={index}>
                            <Link to={"/topic-search/" + rs + "/Small Animals"}>
                              {rs}
                            </Link>
                          </li>
                        );
                      })}
                      <p>TOPICS</p>
                      {suggestionWithSpecialty.map((optionName, index) => {
                        return (
                          <li
                            key={optionName.id}
                            id={recentSearches.length + index}
                          >
                            <Link
                              to={`/topic/${optionName.spc[0].replace(
                                /[^a-zA-Z0-9]/g,
                                "-"
                              )}/${optionName.id}`}
                            >
                              <Highlighter
                                highlightClassName="highlighted-text"
                                searchWords={[searchkey]}
                                autoEscape={true}
                                textToHighlight={optionName.suggestion}
                              />
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              }
              setOptionList(optionsList);
            };
            setSuggestionList(response.data?.hits.hits);
            setFlag(false);
          } else {
            throw new Error("Something went wrong ...");
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }, [getApi, url, searchkey]);

  function changeSearchkey(srchkey) {
    srchkey = srchkey.replace(/[?;//]/g, " ");
    setSearchkey(srchkey);
    if (srchkey !== "") {
    const baseURL = `${config.BASE_URL}search`;
      let autoSuggestUrl = baseURL;
      setUrl(autoSuggestUrl);
      setFlag(true);
    } else {
      setOptionList([]);
    }
  }

  function setCookie(srchkey) {
    var recentValue =
      Cookies.get("searches") !== undefined
        ? Cookies.get("searches").split(",")
        : [];
    if (recentValue.indexOf(srchkey) > -1) {
      recentValue.splice(recentValue.indexOf(srchkey), 1);
    } else if (recentValue.length >= 3) {
      recentValue.shift();
    }
    recentValue.push(srchkey);
    Cookies.set("searches", recentValue.toString());
  }

  const onFormSubmit = (data) => {
    let srchkey = data.searchkey.replace(/[?;//]/g, " ");
    setCookie(srchkey);
    setSearchkey(srchkey);
    setGenus(data.searchgenus);
    localStorage.setItem("genus", data.searchgenus);
    let path = "/topic-search/" + searchkey + "/" + genus + "";
    history.push(path);
  };
  return (
    <div className="searchtopics">
      <Nav
        searchkey={searchkey}
        searchgenus={genus}
        changeSearchkey={(e) => {
          changeSearchkey(e);
        }}
        optionList={optionList}
        onFormSubmit={(e) => {
          onFormSubmit(e);
        }}
      />
    </div>
  );
};

export default TopicNav;
